webpackJsonp([47],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = parseTime;
/* unused harmony export formatTime */
/* harmony export (immutable) */ __webpack_exports__["e"] = readExcel;
/* unused harmony export openImageBox */
/* unused harmony export searchSubStr */
/* harmony export (immutable) */ __webpack_exports__["f"] = removeStr;
/* harmony export (immutable) */ __webpack_exports__["a"] = getOS;
/* harmony export (immutable) */ __webpack_exports__["g"] = transformFileSize;
/* harmony export (immutable) */ __webpack_exports__["b"] = getValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = parseUrlSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx__ = __webpack_require__("uXZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_validate__ = __webpack_require__("E4LH");

/**
 * Created by jiachenpan on 16/11/18.
 */




function parseTime(time, cFormat) {
    if (getOS().isSafari) {
        time = time.replace(/-/g, '/');
    }
    if (arguments.length === 0) {
        return null;
    }
    var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    var date = void 0;
    if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(time)) === 'object') {
        date = time;
    } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
    }
    var formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
    var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
        var value = formatObj[key];
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
        if (result.length > 0 && value < 10) {
            value = '0' + value;
        }
        return value || 0;
    });
    return time_str;
}

function formatTime(time, option) {
    time = +time * 1000;
    var d = new Date(time);
    var now = Date.now();

    var diff = (now - d) / 1000;

    if (diff < 30) {
        return '刚刚';
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前';
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前';
    } else if (diff < 3600 * 24 * 2) {
        return '1天前';
    }
    if (option) {
        return parseTime(time, option);
    } else {
        return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
    }
}

function readExcel(file, callback) {
    var fileReader = new FileReader();
    var persons = []; // 存储获取到的数据
    // 以二进制方式打开文件
    fileReader.readAsBinaryString(file);
    fileReader.onload = function (ev) {
        try {
            var data = ev.target.result,
                workbook = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.read(data, {
                type: 'binary'
            }); // 以二进制流方式读取得到整份excel表格对象
        } catch (e) {
            console.log('文件类型不正确');
            return;
        }

        // 表格的表格范围，可用于判断表头是否数量是否正确
        var fromTo = '';
        // 遍历每张表读取
        for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
                fromTo = workbook.Sheets[sheet]['!ref'];
                persons = persons.concat(__WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_to_json(workbook.Sheets[sheet]));
                // break; // 如果只取第一张表，就取消注释这行
            }
        }
        callback(persons);
    };
}

function openImageBox(url) {
    __WEBPACK_IMPORTED_MODULE_2_element_ui__["MessageBox"].alert('<img src=' + url + ' style="width: 300px;"></img>', '', {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        closeOnClickModal: true,
        center: true
    }).catch(function () {});
}

function searchSubStr(str, subStr) {
    var pos = str.indexOf(subStr),
        positions = [];
    while (pos > -1) {
        positions.push(pos);
        pos = str.indexOf(subStr, pos + 1);
    };
    return positions;
}

function removeStr(content, string) {
    // 获取传入content中符合string的所有位置
    var positions = searchSubStr(content, string),
        str = [];
    // content中存在string的情况
    if (positions.length > 0) {
        // 先保存起始位置至第一个string出现位置的字符串
        str.push(content.substring(0, positions[0]));
        // 使用for循环确保当content中存在多个string时也可正确处理
        for (var i = 0; i < positions.length; i++) {
            var subStr = '';
            // 是否为最后一个position
            if (positions[i + 1]) {
                subStr = content.substring(positions[i], positions[i + 1]);
            } else {
                subStr = content.substring(positions[i]);
            }
            // substr中string前后字符串
            var front = subStr.slice(0, subStr.indexOf('(')),
                after = subStr.slice(subStr.indexOf(')') + 1);
            str.push(front);
            str.push(after);
        };
        return str.join('');
    } else {
        // content中不存在string的情况
        return content;
    }
}

function getOS() {
    var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian,
        isSafari = /Safari/.test(ua) && !/Chrome/.test(ua);
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc,
        isSafari: isSafari
    };
}

// 转换文件大小（按单位）,例如 字节数(bytes) / 1024 返回为 KB
function transformFileSize() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1024;
    var emptyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';

    var number = size > 0 ? size / units : 0;
    return (number > 0 ? number.toFixed(2) : '') || emptyValue;
}

/**
 * 获取某个对象属性的值，支持多级查找
 * @param {Object} obj 被查找的对象
 * @param {number|string|array} _keys 要查找的属性名称，列如：1, 'a.b', 'b.0.a', ['a', 'b']
 * @param {any} defaultValue 找不属性时的默认值
 * @return {any}
 * */
function getValue(obj, _keys, defaultValue) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils_validate__["c" /* isObject */])(obj)) {
        return defaultValue;
    }

    var keys = void 0;
    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_validate__["b" /* isNumber */])(_keys)) {
        _keys = String(_keys);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_validate__["e" /* isString */])(_keys)) {
        keys = _keys.split('.');
    } else {
        keys = Array.isArray(_keys) ? _keys : [];
    }

    var result = keys.reduce(function (parentProp, key) {
        // 如果是 Object or Array 可以尝试获取属性的值
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_validate__["c" /* isObject */])(parentProp) || Array.isArray(parentProp) ? parentProp[key] : undefined;
    }, obj);

    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_validate__["f" /* isUndefined */])(result) ? defaultValue : result;
}

// 解析URL中的参数为Object对象
function parseUrlSearch(search) {
    var paramsList = search.replace(/^[^?]*\?/, '').split('&');
    var params = {};

    paramsList.forEach(function (item) {
        var arr = item.split('=');
        params[arr[0]] = arr[1] || '';
    });

    return params;
}

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "19nU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");




/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.role) {
    return roles.some(function (role) {
      return route.meta.role.indexOf(role) >= 0;
    });
  } else {
    return true;
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
  var accessedRouters = asyncRouterMap.filter(function (route) {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles);
      }
      return true;
    }
    return false;
  });
  return accessedRouters;
}

var permission = {
  state: {
    routers: [], // menu
    addRouters: [] // push routes
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      // 判断是否海外
      var areaType = localStorage.getItem('areaType');
      // this.$router.go(0)
      if (areaType == 0) {
        state.addRouters = routers;
        state.routers = __WEBPACK_IMPORTED_MODULE_2__router__["f" /* constantRouterMap */].concat(routers);
      } else {
        state.addRouters = routers;
        state.routers = __WEBPACK_IMPORTED_MODULE_2__router__["a" /* abroadRouterMap */].concat(routers);
      }
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, userInfo) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var accountType = userInfo.accountType,
            proxyAccount = userInfo.proxyAccount;

        var accessedRouters = [];
        var areaType = localStorage.getItem('areaType');
        if (!proxyAccount) {
          accessedRouters = __WEBPACK_IMPORTED_MODULE_2__router__["d" /* baseRouterMap */];
          if (areaType == 1) {
            if (accountType == 1) {
              accessedRouters = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(accessedRouters), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__router__["b" /* adminAbroadRouterMap */]));
            } else {
              accessedRouters = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(accessedRouters), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__router__["g" /* customerAbroadRouterMap */]));
            }
          } else {
            if (accountType == 1) {
              accessedRouters = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(accessedRouters), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__router__["c" /* adminRouterMap */]));
            } else {
              accessedRouters = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(accessedRouters), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__router__["h" /* customerRouterMap */]));
            }
          }
        } else {
          accessedRouters = __WEBPACK_IMPORTED_MODULE_2__router__["e" /* bindAccountRouterMap */];
        }
        // accessedRouters = [...accessedRouters, ...bindAccountRouterMap]
        // console.log("adminRouterMap**********", accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (permission);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2WTH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarItem__ = __webpack_require__("tlvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ScrollBar__ = __webpack_require__("gzxC");

//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SidebarItem: __WEBPACK_IMPORTED_MODULE_2__SidebarItem__["default"], ScrollBar: __WEBPACK_IMPORTED_MODULE_3__components_ScrollBar__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sidebar', 'permission_routers']), {
    // routes() {
    //   console.log(this.$router.options.routes);
    //   return this.$router.options.routes
    // },

    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  })
});

/***/ }),

/***/ "2gz9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-wrapper"},[_vm._l((_vm.routes),function(item){return (!_vm.hidePage(item))?[(!item.hidden&&item.children&&item.children.length===1)?_c('router-link',{key:item.children[0].name,attrs:{"to":item.path+'/'+item.children[0].path}},[_c('el-menu-item',{staticClass:"submenu-title-noDropdown",attrs:{"index":item.path+'/'+item.children[0].path}},[(item.children[0].meta&&item.children[0].meta.icon)?_c('svg-icon',{attrs:{"icon-class":item.children[0].meta.icon}}):_vm._e(),_vm._v(" "),(item.children[0].meta&&item.children[0].meta.title)?_c('span',[((_vm.userId == 653 || _vm.userId == 1016 || _vm.userId == 2990) && item.children[0].meta.title == 'CPA广告')?[_vm._v("非标广告")]:[_vm._v(_vm._s(item.children[0].meta.title))]],2):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(!item.hidden&&item.children&&item.children.length>1)?_c('el-submenu',{key:item.name,attrs:{"index":item.name||item.path}},[_c('template',{slot:"title"},[_c('router-link',{attrs:{"to":item.path}},[(item.meta&&item.meta.icon)?_c('svg-icon',{attrs:{"icon-class":item.meta.icon}}):_vm._e(),_vm._v(" "),(item.meta&&item.meta.title)?_c('span',[_vm._v(_vm._s(item.meta.title))]):_vm._e()],1)],1),_vm._v(" "),_vm._l((item.children),function(child){return (!child.hidden)?[(child.children&&child.children.length>0)?_c('sidebar-item',{key:child.path,staticClass:"nest-menu",attrs:{"routes":[child]}}):_c('router-link',{key:child.name,attrs:{"to":item.path+'/'+child.path}},[_c('el-menu-item',{attrs:{"index":item.path+'/'+child.path}},[(child.meta&&child.meta.icon)?_c('svg-icon',{attrs:{"icon-class":child.meta.icon}}):_vm._e(),_vm._v(" "),(child.meta&&child.meta.title)?_c('span',[_vm._v(_vm._s(child.meta.title))]):_vm._e()],1)],1)]:_vm._e()})],2):_vm._e()]:_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3JNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-video\"><defs><style type=\"text/css\"></style></defs><path d=\"M935.466106 186.149631 86.484212 186.149631c-13.734816 0-24.970718 11.235902-24.970718 24.970718l0 586.771961c0 13.728676 11.235902 24.969695 24.970718 24.969695l848.981894 0c13.739932 0 24.969695-11.241019 24.969695-24.969695L960.435801 211.121372C960.432731 197.386556 949.206038 186.149631 935.466106 186.149631L935.466106 186.149631zM196.510094 735.466538c0 6.855128-5.621021 12.485359-12.486382 12.485359l-56.17951 0c-6.864338 0-12.486382-5.630231-12.486382-12.485359l0-56.180534c0-6.879688 5.621021-12.485359 12.486382-12.485359l56.17951 0c6.864338 0 12.486382 5.606695 12.486382 12.485359L196.510094 735.466538 196.510094 735.466538zM196.510094 598.133729c0 6.850012-5.621021 12.485359-12.486382 12.485359l-56.17951 0c-6.864338 0-12.486382-5.635347-12.486382-12.485359l0-56.180534c0-6.879688 5.621021-12.483312 12.486382-12.483312l56.17951 0c6.864338 0 12.486382 5.604648 12.486382 12.483312L196.510094 598.133729 196.510094 598.133729zM196.510094 467.061508c0 6.864338-5.621021 12.487406-12.486382 12.487406l-56.17951 0c-6.864338 0-12.486382-5.622044-12.486382-12.487406l0-56.180534c0-6.864338 5.621021-12.485359 12.486382-12.485359l56.17951 0c6.864338 0 12.486382 5.621021 12.486382 12.485359L196.510094 467.061508 196.510094 467.061508zM196.510094 329.727677c0 6.864338-5.621021 12.485359-12.486382 12.485359l-56.17951 0c-6.864338 0-12.486382-5.619998-12.486382-12.485359l0-56.181557c0-6.864338 5.621021-12.485359 12.486382-12.485359l56.17951 0c6.864338 0 12.486382 5.621021 12.486382 12.485359L196.510094 329.727677 196.510094 329.727677zM766.917342 739.63958c0 13.728676-11.226692 24.969695-24.968671 24.969695L280.00267 764.609275c-13.732769 0-24.969695-11.241019-24.969695-24.969695L255.032976 268.862447c0-13.733792 11.236925-24.970718 24.969695-24.970718l461.946001 0c13.743002 0 24.968671 11.236925 24.968671 24.970718L766.917342 739.63958 766.917342 739.63958zM906.592498 735.466538c0 6.855128-5.622044 12.485359-12.486382 12.485359l-56.17951 0c-6.865361 0-12.485359-5.630231-12.485359-12.485359l0-56.180534c0-6.879688 5.619998-12.485359 12.485359-12.485359l56.17951 0c6.864338 0 12.486382 5.606695 12.486382 12.485359L906.592498 735.466538 906.592498 735.466538zM906.592498 598.133729c0 6.850012-5.622044 12.485359-12.486382 12.485359l-56.17951 0c-6.865361 0-12.485359-5.635347-12.485359-12.485359l0-56.180534c0-6.879688 5.619998-12.483312 12.485359-12.483312l56.17951 0c6.864338 0 12.486382 5.604648 12.486382 12.483312L906.592498 598.133729 906.592498 598.133729zM906.592498 467.061508c0 6.864338-5.622044 12.487406-12.486382 12.487406l-56.17951 0c-6.865361 0-12.485359-5.622044-12.485359-12.487406l0-56.180534c0-6.864338 5.619998-12.485359 12.485359-12.485359l56.17951 0c6.864338 0 12.486382 5.621021 12.486382 12.485359L906.592498 467.061508 906.592498 467.061508zM906.592498 329.727677c0 6.864338-5.622044 12.485359-12.486382 12.485359l-56.17951 0c-6.865361 0-12.485359-5.619998-12.485359-12.485359l0-56.181557c0-6.864338 5.619998-12.485359 12.485359-12.485359l56.17951 0c6.864338 0 12.486382 5.621021 12.486382 12.485359L906.592498 329.727677 906.592498 329.727677zM410.788365 619.968014l231.058446-115.2867L410.788365 389.036457 410.788365 619.968014zM410.788365 619.968014\" p-id=\"2550\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "3TAY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__("TIfe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getBreadcrumb();
  },
  data: function data() {
    return {
      levelList: null,
      userId: JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["a" /* getToken */])()).userId
    };
  },

  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  },
  methods: {
    getBreadcrumb: function getBreadcrumb() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && first.name !== '首页') {
        matched = [{ path: '/admanage', meta: { title: '首页' } }].concat(matched);
      }
      this.levelList = matched;
    }
  }
});

/***/ }),

/***/ "3eCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tree",
  "use": "icon-tree-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tree\"><defs><style type=\"text/css\"></style></defs><path d=\"M1013.703 693.345c6.865 6.865 10.297 14.874 10.297 24.027l0 205.944c0 9.916-3.432 18.115-10.297 24.599-6.865 6.483-15.255 9.725-25.171 9.725L782.588 957.64c-9.153 0-17.162-3.242-24.027-9.725-6.865-6.483-10.297-14.683-10.297-24.599L748.264 717.372c0-6.102 1.526-11.823 4.577-17.162s7.246-9.534 12.586-12.586 11.06-4.577 17.162-4.577l77.801 0L860.39 546.896c0-4.577-1.144-8.772-3.432-12.586s-5.339-6.865-9.153-9.153-8.009-3.432-12.585-3.432L543.464 521.725l0 161.323 77.801 0c9.153 0 17.162 3.432 24.027 10.297s10.297 14.874 10.297 24.027l0 205.944c0 6.102-1.526 11.823-4.577 17.162s-7.246 9.534-12.585 12.585-11.06 4.577-17.162 4.577L415.321 957.64c-6.102 0-11.823-1.526-17.162-4.577s-9.725-7.246-13.158-12.585-5.149-11.06-5.149-17.162L379.852 717.372c0-9.153 3.432-17.162 10.297-24.027s15.255-10.297 25.171-10.297l76.657 0L491.977 521.725 188.782 521.725c-7.628 0-13.92 2.479-18.878 7.437-4.958 4.958-7.437 10.869-7.437 17.734l0 136.152 77.801 0c9.916 0 18.115 3.432 24.599 10.297s9.725 14.874 9.725 24.027l0 205.944c0 9.916-3.242 18.115-9.725 24.599-6.483 6.483-14.683 9.725-24.599 9.725L34.324 957.64c-3.814 0-7.437-0.572-10.869-1.716-3.432-1.144-6.483-2.67-9.153-4.577-2.67-1.907-5.149-4.386-7.437-7.437-2.288-3.051-4.004-6.293-5.149-9.725C0.572 930.753 0 927.13 0 923.316L0 717.372c0-3.051 0.381-6.102 1.144-9.153s1.907-5.721 3.432-8.009 3.432-4.577 5.721-6.865 4.577-4.195 6.865-5.721 4.958-2.67 8.009-3.432 6.102-1.144 9.153-1.144l77.801 0L112.125 495.41c0-6.865 2.479-12.776 7.437-17.734s10.869-7.437 17.734-7.437l354.682 0L491.978 342.096l-76.657 0c-9.916 0-18.306-3.432-25.171-10.297s-10.297-14.874-10.297-24.027L379.853 101.828c0-9.916 3.432-18.306 10.297-25.171s15.255-10.297 25.171-10.297l205.944 0c6.102 0 11.823 1.716 17.162 5.149 5.339 3.432 9.534 7.818 12.585 13.158 3.051 5.339 4.577 11.06 4.577 17.162l0 205.944c0 9.153-3.432 17.162-10.297 24.027s-14.874 10.297-24.027 10.297l-77.801 0 0 128.143L885.56 470.24c7.628 0 13.92 2.479 18.878 7.437s7.437 10.869 7.437 17.734l0 187.638 76.657 0C998.448 683.048 1006.838 686.48 1013.703 693.345z\" p-id=\"3508\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "4+ci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-bar',[_c('el-menu',{attrs:{"mode":"vertical","unique-opened":"","default-active":_vm.$route.path,"collapse":_vm.isCollapse,"background-color":"#304156","text-color":"#fff","active-text-color":"#409EFF"}},[_c('sidebar-item',{attrs:{"routes":_vm.permission_routers}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4wdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-eye",
  "use": "icon-eye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-eye\"><defs><style type=\"text/css\"></style></defs><path d=\"M941.677063 391.710356c9.337669-14.005992 6.224772-32.68133-6.224772-43.575447-14.005992-10.894118-32.68133-7.78122-43.575447 6.224771-1.556449 1.556449-174.300768 205.426673-379.727441 205.426673-199.200878 0-379.727441-205.426673-381.28389-206.982098-10.894118-12.450567-31.124881-14.005992-43.575448-3.112898-12.450567 10.894118-14.005992 31.124881-3.112897 43.575448 3.112897 4.668323 40.46255 46.687322 99.600439 93.375667l-79.369676 82.48155c-12.450567 12.450567-10.894118 32.68133 1.556449 43.575448 3.112897 6.224772 10.894118 9.337669 18.675338 9.337669 7.78122 0 15.562441-3.112897 21.787213-9.337669l85.594447-88.706321c40.46255 28.013007 88.706321 54.469566 141.619438 73.14388L340.959485 707.631586c-4.668323 17.118889 4.669346 34.237779 21.787213 38.906101h9.337669c14.005992 0 26.456558-9.337669 29.568432-23.343661l32.68133-110.494556c24.90011 4.668323 51.356668 7.78122 77.813227 7.78122s52.913117-3.112897 77.813227-7.78122l32.68133 108.938108c3.112897 14.005992 17.118889 23.343661 29.569456 23.343661 3.112897 0 6.224772 0 7.78122-1.556449 17.118889-4.669346 26.456558-21.787212 21.788236-38.906102l-32.68133-108.938108c52.913117-18.675338 101.156888-45.131897 141.619438-73.14388l84.037998 87.150896c6.224772 6.224772 14.005992 9.337669 21.787212 9.337669 7.78122 0 15.562441-3.112897 21.787212-9.337669 12.450567-12.450567 12.450567-31.124881 1.556449-43.575448l-79.369675-82.48155c63.808258-46.688345 101.158934-91.820242 101.158934-91.820242z\" p-id=\"7879\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "52Rn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5tQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.svgClass,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6gxQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__("6k2e");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__("WTox");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__("BoPo");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TagsView__ = __webpack_require__("Vg/Y");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__TagsView__["default"]; });





/***/ }),

/***/ "6k2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("gPq7");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d601c52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("n6L1");
function injectStyle (ssrContext) {
  __webpack_require__("svnb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d601c52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d601c52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "90Fk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./password.svg": "QjmH",
	"./table.svg": "oSYw",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./video.svg": "3JNx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";

/***/ }),

/***/ "A66B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (file) {
  return function () {
    return __webpack_require__("Opzk")("./" + file + '.vue');
  };
};

/***/ }),

/***/ "AkUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("aret");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5179ff2a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("CVQ1");
function injectStyle (ssrContext) {
  __webpack_require__("52Rn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5179ff2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5179ff2a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "B42Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BoPo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__ = __webpack_require__("Ck6p");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_285a852f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__ = __webpack_require__("wE0Q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_285a852f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Bpxs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C3aA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'svg-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    },
    svgClass: function svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    }
  }
});

/***/ }),

/***/ "CV2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainer",staticClass:"scroll-container",on:{"mousewheel":_vm.handleScroll}},[_c('div',{ref:"scrollWrapper",staticClass:"scroll-wrapper",style:({top: _vm.top + 'px'})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CVQ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:{hideSidebar:!_vm.sidebar.opened}},[_c('sidebar',{staticClass:"sidebar-container"}),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('navbar'),_vm._v(" "),_c('tags-view'),_vm._v(" "),_c('app-main')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ck6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
});

/***/ }),

/***/ "E4LH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isvalidUsername */
/* harmony export (immutable) */ __webpack_exports__["d"] = isProxy;
/* unused harmony export validateURL */
/* unused harmony export validateLowerCase */
/* unused harmony export validateUpperCase */
/* unused harmony export validatAlphabets */
/* harmony export (immutable) */ __webpack_exports__["i"] = validateInteger;
/* harmony export (immutable) */ __webpack_exports__["g"] = validateFloat;
/* harmony export (immutable) */ __webpack_exports__["c"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["f"] = isUndefined;
/* harmony export (immutable) */ __webpack_exports__["e"] = isString;
/* harmony export (immutable) */ __webpack_exports__["k"] = validateLocalImg;
/* harmony export (immutable) */ __webpack_exports__["h"] = validateImgMeasure;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateLocalFile;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoInfo; });
/* unused harmony export localFileToBase64 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);





/**
 * Created by jiachenpan on 16/11/18.
 */

function isvalidUsername(str) {
    var valid_map = ['admin', 'editor'];
    return valid_map.indexOf(str.trim()) >= 0;
}

// 是否是代投
function isProxy() {
    return location.href.indexOf('fuguifanrongwl.com') > -1;
}

/* 合法uri*/
function validateURL(textval) {
    var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
    return urlregex.test(textval);
}

/* 小写字母*/
function validateLowerCase(str) {
    var reg = /^[a-z]+$/;
    return reg.test(str);
}

/* 大写字母*/
function validateUpperCase(str) {
    var reg = /^[A-Z]+$/;
    return reg.test(str);
}

/* 大小写字母*/
function validatAlphabets(str) {
    var reg = /^[A-Za-z]+$/;
    return reg.test(str);
}

/*
 * 是否为整数
 * 2019.2.25 修改自李贤波
 * 修改原因：当传入数值转化为二进制后位数超过32位，此时使用 | 运算符时将报错
 */
function validateInteger(num) {
    // 2019.2.25移除
    // return (num | 0) == num;
    // 2019.2.25新增
    if (typeof num === 'number') {
        return num % 1 === 0;
    } else if (typeof num === 'string') {
        return num.indexOf('.') < 0 && num % 1 === 0;
    } else {
        return false;
    }
}

/**
 * 校验是浮点数字（不含负数）可用性
 * @param value: 必选，被校验的值 (.11 这样的数字在校验时会自动转为0.11)
 * @param length: 可选，浮点位数，默认 2
 * */
function validateFloat(value) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    return new RegExp('^\\d+(?:\\.\\d{1,' + length + '})?$').test(value);
}

/**
 * 校验是否为一个Object对象
 * @param target: 需要校验的目标
 * @param isEmpty: Boolean 是否允许为空对象
 * */
function isObject(target, isEmpty) {
    // if (typeof target !== 'object') return false;
    if (Object.prototype.toString.call(target) !== '[object Object]') return false;
    if (!isEmpty) return true;
    for (var key in target) {
        if (target.hasOwnProperty(key)) return true;
    }
    return false;
}

function isNumber(target) {
    if (typeof target === 'number') {
        return target === 0 || !!target;
    } else {
        return (/^-?(\d+\.)?\d+$/.test(target)
        );
    }
}

function isUndefined(value) {
    return typeof value === 'undefined';
}

function isString(value) {
    return typeof value === 'string';
}

// 默认的文件校验规则
var defaultFileRules = {
    size: 500, // 500KB
    accept: /[./](gif|jpe?g|png)$/i, // 图片格式
    hasRatio: false // 是否需要校验高宽比例
};

/**
 * 根据条件校验本地图片信息，返回Promise的处理结果
 * @param file: 通过el-upload选择的单个文件对象
 * @param _rules: 文件的校验规则
 *        _rules: { accept, size, minWidth, maxWidth, minHeight, maxHeight, noRatio, 'tips' }
 * */
function validateLocalImg(file, _rules) {
    var rules = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, defaultFileRules, _rules);
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // console.log('validateLocalImg:', rules, file);
        var raw = file.raw;
        if (!!raw.type.trim() && !rules.accept.test(raw.type) || !rules.accept.test(raw.name)) {
            return reject('\u56FE\u7247\u683C\u5F0F\u4E0D\u6B63\u786E!', 'type');
        }

        // 校验文件大小，单位KB
        var sizeExceeded = file.size / 1024 > rules.size;
        if (sizeExceeded) {
            return reject('\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7' + rules.size + 'KB!', 'size');
        }

        // 校验图片的尺寸
        var image = new Image();
        image.onload = function () {
            var width = image.width,
                height = image.height;

            var measure = { width: width, height: height };

            if (!validateImgMeasure(measure, rules)) {
                // 提示建议的比例和范围
                var info = rules.ratio && rules.range ? '\uFF0C\u5EFA\u8BAE' + rules.ratio + '\uFF0C' + rules.range : '';
                reject(rules.tips || '\u56FE\u7247\u5C3A\u5BF8\u4E0D\u6B63\u786E' + info + '!', 'measure');
            } else {
                resolve({
                    name: file.name,
                    measure: measure,
                    // src: URL.createObjectURL(file.raw),
                    src: file.url,
                    uid: file.uid,
                    status: 'loading' // ready
                });
            }
        };
        image.onerror = function () {
            reject('图片读取失败');
        };
        image.src = file.url;
    });
}

// 校验图片长宽比例与尺寸
function validateImgMeasure(_ref) {
    var width = _ref.width,
        height = _ref.height;
    var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // 长 scaleLength=width, 宽 scaleWidth=height
    var ruleRatio = rules.hasRatio ? rules.ratio || rules.scaleLength / rules.scaleWidth : 0;
    var imgRatio = rules.hasRatio ? width / height : 0;
    var squareSize = rules.squareSize;
    if (squareSize) {
        // 正方形尺寸
        rules = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, rules, {
            minWidth: squareSize,
            maxWidth: squareSize,
            minHeight: squareSize,
            maxHeight: squareSize
        });
    }
    return !(
    // `hasRatio` 需要校验比例
    rules.hasRatio && (ruleRatio !== imgRatio || Math.abs(ruleRatio - imgRatio) > 0.001) || width < rules.minWidth || height < rules.minHeight || width > rules.maxWidth || height > rules.maxHeight);
}

// 校验本地文件的格式与大小
function validateLocalFile(file, _rules) {
    var rules = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, defaultFileRules, _rules);
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var raw = file.raw;
        if (!!raw.type.trim() && !rules.accept.test(raw.type)) // || !rules.accept.test(raw.name)
            {
                return reject('\u6587\u4EF6\u683C\u5F0F\u4E0D\u6B63\u786E!', 'type');
            }

        // 校验文件大小，单位KB
        var sizeExceeded = file.size / 1024 > rules.size;
        if (sizeExceeded) {
            return reject('\u60A8\u4E0A\u4F20\u7684\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7' + rules.size + 'KB!', 'size');
        }

        resolve({
            name: file.name,
            src: file.url,
            uid: file.uid,
            status: 'loading' // ready
        });
    });
}

/**
 * 获取视频信息，返回Promise的处理结果
 * @param {string} url: 必填，视频文件URL
 * @param [options] 可选项，可额外返回某一帧的图片(imgBase64)及文件(imgFile:Blob)
 * @param {boolean} [options.needFile] 是否获取图片文件
 * @param {number} [options.currentTime] 指定帧(默认0.02)
 * @param {number} [options.quality] 图片质量(默认1.0)
 * @param {number} [options.fileSize] 文件大小(字节)，用于计算码率
 * @return Promise {width, height, duration, kbps?, type, imgBase64?, imgFile?}
 */
var getVideoInfo = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(url, options) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            if (!url) {
                                reject('缺少文件URL');
                                return;
                            }
                            var video = window.document.createElement('video');
                            var ops = isObject(options) ? options : {};
                            // video.volume = 0;
                            video.muted = true; // 静音
                            video.crossOrigin = 'anonymous'; // 跨域

                            // 监听已加载第一帧
                            // 更多事件 durationchange canplay canplaythrough
                            // https://developer.mozilla.org/zh-CN/docs/Web/HTML/Element/video#事件
                            video.addEventListener('loadeddata', function (e) {
                                var _this = this;

                                // 获取帧数可参考以下资料
                                // https://developer.mozilla.org/zh-CN/docs/Web/API/HTMLVideoElement
                                // https://github.com/mdn/sprints/issues/2250
                                // 总时长，单位为秒（小数部分将被四舍五入）
                                var duration = Math.round(this.duration || 0);
                                var res = {
                                    width: this.videoWidth,
                                    height: this.videoHeight,
                                    duration: duration
                                };
                                if (options) {
                                    if (ops.fileSize) {
                                        // 视频文件的码率的算法：码率(Kbps，Kb每秒)=文件大小(KB) * 8(B=Byte字节，1KB=8Kb) / 时间(秒)
                                        // 注意：此处未区分音频与视频，因此计算会有误差。
                                        res.kbps = (ops.fileSize / 1024 * 8 / duration || 0).toFixed(0);
                                    }
                                    // 注意：部分浏览器中，可能需要等待一定时间才能将视频内容渲染至 Canvas
                                    setTimeout(function () {
                                        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(res, captureImage(_this, ops));
                                        resolve(res);
                                        video.remove();
                                    }, 10);
                                } else {
                                    resolve(res);
                                    video.remove();
                                }
                            });

                            // 监听错误
                            video.addEventListener('error', function () {
                                video.remove();
                                reject('读取视频信息失败');
                            });

                            video.src = url;
                            if (options) {
                                video.currentTime = ops.currentTime || 0.00; // 设定播放位置
                            }
                            // video.setAttribute('style', `position: fixed;z-index: 99999;left: 10px;top: 10px;background-color: rgba(0,0,0,0.5);`);
                            // window.document.querySelector('body').append(video);
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getVideoInfo(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

// 捕捉视频的某帧的数据
function captureImage(videoTarget, _ref3) {
    var type = _ref3.type,
        name = _ref3.name,
        needFile = _ref3.needFile,
        quality = _ref3.quality;

    // 创建一个画布
    var canvas = window.document.createElement('canvas');
    // 设置为视频的尺寸
    canvas.width = videoTarget.videoWidth || 100;
    canvas.height = videoTarget.videoHeight || 100;
    canvas.getContext('2d').drawImage(videoTarget, 0, 0, canvas.width, canvas.height);

    var imgType = type || 'image/jpeg';
    // base64模式的图片
    var imgBase64 = canvas.toDataURL(imgType, quality || 1.0);
    // 图片文件数据，可直接上传服务器
    var imgFile = needFile ? dataURItoBlob(imgBase64, name) : null;

    canvas.remove();
    return {
        imgBase64: imgBase64,
        imgFile: imgFile,
        imgPostfix: imgType.replace(/.*\//, '') // 图片文件后缀
    };
}

// 将Base64的图片数据转换成Blob
function dataURItoBlob() {
    var base64Data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var byteString = void 0;

    var _base64Data$split = base64Data.split(','),
        _base64Data$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_base64Data$split, 2),
        _base64Data$split2$ = _base64Data$split2[0],
        before = _base64Data$split2$ === undefined ? '' : _base64Data$split2$,
        _base64Data$split2$2 = _base64Data$split2[1],
        content = _base64Data$split2$2 === undefined ? '' : _base64Data$split2$2;

    if (before && content) {
        if (before.indexOf('base64') >= 0) {
            // base64数据
            // 解码base64字符串
            byteString = atob(content);
        } else {
            // 其他
            // 解码通过escape转义编码的字符串
            byteString = unescape(content); // 此方法已从 Web 标准中删除
        }
    } else {
        return null;
    }

    // 读取文件的MIME类型
    var mimeString = before.split(':')[1].split(';')[0];
    // 准备`二进制补码8位无符号整数`的数组
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        // 逐个获取UTF-16编码单元的数字，并添加至数组对应的位置
        ia[i] = byteString.charCodeAt(i);
    }

    // blob的内容由参数数组中给出的值的串联组成
    var blob = new Blob([ia], { type: mimeString });
    blob.name = (filename || String(Date.now())).replace(/\.\w*$/, '.' + mimeString.replace(/.*\//, ''));
    return blob;
}

// 将本地图片文件的内容转为 Base64 字符串
var localFileToBase64 = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(file) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            // 参考 https://developer.mozilla.org/zh-CN/docs/Web/API/FileReader
                            var reader = new FileReader();
                            // 即将被读取的 Blob 或 File 对象。
                            // URL格式的字符串（base64编码）以表示所读取文件的内容
                            reader.readAsDataURL(file);
                            // 读取操作完成后返回包含 result 的 reader 对象
                            reader.onload = function () {
                                reader.url = URL.createObjectURL(file);
                                resolve(reader);
                            };
                            reader.onerror = reject;
                        }));

                    case 1:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function localFileToBase64(_x7) {
        return _ref4.apply(this, arguments);
    };
}();

/***/ }),

/***/ "EwA0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GcOB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I4X8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_tagsView__ = __webpack_require__("Zq5Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_permission__ = __webpack_require__("19nU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getters__ = __webpack_require__("UjVw");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_5__modules_permission__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    tagsView: __WEBPACK_IMPORTED_MODULE_4__modules_tagsView__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_6__getters__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "KWC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{staticClass:"svg-icon hamburger",class:{'is-active':_vm.isActive},attrs:{"t":"1492500959545","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"1691","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"64","height":"64"},on:{"click":_vm.toggleClick}},[_c('path',{attrs:{"d":"M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z","p-id":"1692"}}),_vm._v(" "),_c('path',{attrs:{"d":"M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z","p-id":"1693"}}),_vm._v(" "),_c('path',{attrs:{"d":"M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z","p-id":"1694"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kq96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"app-breadcrumb",attrs:{"separator":"/"}},[_c('transition-group',{attrs:{"name":"breadcrumb"}},_vm._l((_vm.levelList),function(item,index){return (item.meta.title)?_c('el-breadcrumb-item',{key:item.path},[(item.redirect==='noredirect'||index==_vm.levelList.length-1)?_c('span',{staticClass:"no-redirect"},[((_vm.userId == 653 || _vm.userId == 1016 || _vm.userId == 2990) && item.meta.title == 'CPA广告')?[_vm._v("非标广告")]:[_vm._v(_vm._s(item.meta.title))]],2):_c('router-link',{attrs:{"to":item.redirect||item.path}},[((_vm.userId == 653 || _vm.userId == 1016 || _vm.userId == 2990) && item.meta.title == 'CPA广告')?[_vm._v("非标广告")]:[_vm._v(_vm._s(item.meta.title))]],2)],1):_vm._e()}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17ab6bd8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("p7/o");
function injectStyle (ssrContext) {
  __webpack_require__("MVzk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17ab6bd8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = postLogin;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInfo;
/* unused harmony export logout */
/* harmony export (immutable) */ __webpack_exports__["a"] = getImgCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5__ = __webpack_require__("NC6I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_md5__);


// 用户登录
function postLogin(username, password, imgValidateCode) {
  var password = __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(password);
  var imgValidateCode = __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(imgValidateCode.toLowerCase());
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/login?channel=1',
    method: 'post',
    // header: imgValidateCode,
    headers: { 'imgValidateCode': imgValidateCode },
    data: {
      username: username,
      password: password,
      imgValidateCode: imgValidateCode
    }
  });
}
// 查询用户信息
function getInfo(token) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/account/getAccountInfo',
    method: 'get',
    headers: { 'token': token },
    params: {
      channel: 1
    }
  });
}
// 登出
function logout() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/user/logout?channel=1',
    method: 'post'
  });
}
// 验证码
function getImgCode(width, height) {
  var width = width || "";
  var height = height || "";
  return "https://cpcapi.fuguifanrongwl.com/" + 'getImgValidate?channel=1&interference_line_num=0&width=' + width + "&height=" + height + "&random=" + Math.random();
}

/***/ }),

/***/ "MVzk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_wangEditor_scss__ = __webpack_require__("GcOB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_wangEditor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_wangEditor_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons__ = __webpack_require__("Q7M0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__permission__ = __webpack_require__("kTXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_polyfill__);




// import locale from 'element-ui/lib/locale/lang/cn'



 // icon
 // 权限


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/*
* 因为服务端的登录问题，推荐使用火狐浏览器，或者谷歌浏览器（但需要做一些额外配置）
*  */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["i" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ "OOLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-example",
  "use": "icon-example-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-example\"><defs><style type=\"text/css\"></style></defs><path d=\"M770.56 460.8h250.88C998.4 220.16 803.84 25.6 563.2 2.56v250.88c104.96 20.48 186.88 102.4 207.36 207.36z m0 0M460.8 253.44V2.56C220.16 25.6 25.6 220.16 2.56 460.8h250.88c20.48-104.96 102.4-186.88 207.36-207.36z m0 0M563.2 770.56v250.88c243.2-23.04 435.2-217.6 460.8-460.8H773.12C750.08 668.16 668.16 750.08 563.2 770.56z m0 0M253.44 563.2H2.56c23.04 243.2 217.6 435.2 460.8 460.8V773.12C355.84 750.08 273.92 668.16 253.44 563.2z m0 0\" fill=\"\" p-id=\"1816\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Opzk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": [
		"+H76",
		33
	],
	"./account/index.vue": [
		"0FZS",
		32
	],
	"./adadmin/BudgetDialog.vue": [
		"duAT",
		31
	],
	"./adadmin/_components/AddressCity.vue": [
		"AsmB",
		44
	],
	"./adadmin/_components/AddressList.vue": [
		"HgtP",
		13
	],
	"./adadmin/_components/AdserSelect.vue": [
		"BBZK",
		38
	],
	"./adadmin/_components/Preview.vue": [
		"52Vh",
		43
	],
	"./adadmin/_components/TimAreaNoBudge.vue": [
		"FibZ",
		45
	],
	"./adadmin/_components/TimeArea.vue": [
		"RRzZ",
		42
	],
	"./adadmin/_components/batchUpdate.vue": [
		"oYZB",
		2
	],
	"./adadmin/create.vue": [
		"cZRx",
		0
	],
	"./adadmin/createQualify/index.vue": [
		"yPdK",
		8
	],
	"./adadmin/index.vue": [
		"5uGQ",
		1
	],
	"./adadmin/qualifyManagement/components/Qualify.vue": [
		"QShJ",
		21
	],
	"./adadmin/qualifyManagement/index.vue": [
		"jOTT",
		12
	],
	"./adadmin/videoManagement/adadminCreateVideo.vue": [
		"oI9j",
		20
	],
	"./adadmin/videoManagement/index.vue": [
		"k3uL",
		9
	],
	"./arrears/index.vue": [
		"nXu/",
		19
	],
	"./cpa/index.vue": [
		"6DpS",
		18
	],
	"./cpc/index.vue": [
		"Q11n",
		17
	],
	"./dashboard/index.vue": [
		"ARoL",
		41
	],
	"./diysite/addDiysite.vue": [
		"+iwM",
		6
	],
	"./diysite/components/DetailTemplate.vue": [
		"njRO",
		40
	],
	"./diysite/components/DiysiteDetail.vue": [
		"TuH4",
		10
	],
	"./diysite/components/Numbers.vue": [
		"+N2R",
		39
	],
	"./diysite/editDiysite.vue": [
		"8EDW",
		5
	],
	"./diysite/index.vue": [
		"CegG",
		4
	],
	"./diysite/templates.vue": [
		"KDi1",
		37
	],
	"./finance/components/editPrice.vue": [
		"bU4E",
		14
	],
	"./finance/index.vue": [
		"qDpw",
		11
	],
	"./forget/index.vue": [
		"H0Tk",
		16
	],
	"./layout/Layout.vue": [
		"AkUR"
	],
	"./layout/components/AppMain.vue": [
		"BoPo"
	],
	"./layout/components/Navbar.vue": [
		"6k2e"
	],
	"./layout/components/Sidebar/SidebarItem.vue": [
		"tlvQ"
	],
	"./layout/components/Sidebar/index.vue": [
		"WTox"
	],
	"./layout/components/TagsView.vue": [
		"Vg/Y"
	],
	"./login/index.vue": [
		"T+/8",
		30
	],
	"./logs/index.vue": [
		"x2QC",
		29
	],
	"./notice/index.vue": [
		"FxGV",
		7
	],
	"./order/index.vue": [
		"e+iX",
		36
	],
	"./order/items.vue": [
		"3Uug",
		35
	],
	"./placeData/index.vue": [
		"fGXe",
		28
	],
	"./position/index.vue": [
		"r7pC",
		27
	],
	"./register/index.vue": [
		"bqOp",
		15
	],
	"./subaccount/AccountDialog.vue": [
		"J51q",
		26
	],
	"./subaccount/AccountRecords.vue": [
		"QO/7",
		25
	],
	"./subaccount/BalanceDialog.vue": [
		"P+X6",
		24
	],
	"./subaccount/BalanceDialogsub.vue": [
		"EANo",
		34
	],
	"./subaccount/index.vue": [
		"bOiM",
		3
	],
	"./subfinance/index.vue": [
		"zdl1",
		23
	],
	"./sublogs/index.vue": [
		"M+Vt",
		22
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "Q7M0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SvgIcon__ = __webpack_require__("wp/i");

 // svg组件

// register globally
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('svg-icon', __WEBPACK_IMPORTED_MODULE_1__components_SvgIcon__["a" /* default */]);

var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};
var req = __webpack_require__("90Fk");
requireAll(req);

/***/ }),

/***/ "QjmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-password\"><defs><style type=\"text/css\"></style></defs><path d=\"M780.8 354.579692 665.6 354.579692 665.6 311.689846c0-72.310154-19.849846-193.299692-153.6-193.299692-138.870154 0-153.6 135.049846-153.6 193.299692l0 42.889846L243.2 354.579692 243.2 311.689846C243.2 122.249846 348.790154 0 512 0s268.8 122.249846 268.8 311.689846L780.8 354.579692zM588.8 669.420308C588.8 625.900308 554.220308 590.769231 512 590.769231s-76.8 35.131077-76.8 78.651077c0 29.459692 15.399385 54.468923 38.439385 67.820308l0 89.639385c0 21.740308 17.250462 39.699692 38.4 39.699692s38.4-17.959385 38.4-39.699692l0-89.639385C573.44 723.889231 588.8 698.88 588.8 669.420308zM896 512l0 393.609846c0 65.260308-51.869538 118.390154-115.2 118.390154L243.2 1024c-63.291077 0-115.2-53.129846-115.2-118.390154L128 512c0-65.220923 51.869538-118.390154 115.2-118.390154l537.6 0C844.130462 393.609846 896 446.779077 896 512z\" p-id=\"9230\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "SM0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
});

/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var TokenKey = 'Admin-Cpc-Token';

function getToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(TokenKey);
}

function setToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, token);
}

function removeToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(TokenKey);
}

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  token: function token(state) {
    return state.user.token;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routers: function permission_routers(state) {
    return state.permission.routers;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "UqIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("3TAY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b04d497_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Kq96");
function injectStyle (ssrContext) {
  __webpack_require__("bn4E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b04d497"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b04d497_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VdD3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user\"><defs><style type=\"text/css\"></style></defs><path d=\"M504.951 511.98c93.49 0 169.28-74.002 169.28-165.26 0-91.276-75.79-165.248-169.28-165.248-93.486 0-169.287 73.972-169.279 165.248-0.001 91.258 75.793 165.26 169.28 165.26z m77.6 55.098H441.466c-120.767 0-218.678 95.564-218.678 213.45V794.3c0 48.183 97.911 48.229 218.678 48.229H582.55c120.754 0 218.66-1.78 218.66-48.229v-13.77c0-117.887-97.898-213.45-218.66-213.45z\" p-id=\"7987\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Vg/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagsView_vue__ = __webpack_require__("X7ex");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfd2b3b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagsView_vue__ = __webpack_require__("uXQy");
function injectStyle (ssrContext) {
  __webpack_require__("EwA0")
  __webpack_require__("hRxV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dfd2b3b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfd2b3b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var app = {
  state: {
    sidebar: {
      opened: !+__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('sidebarStatus')
    },
    uploadUrl: "https://cpcapi.fuguifanrongwl.com/" + 'advertiser/uploadAdTicketImg?channel=1'
  },
  mutations: {
    TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
      if (state.sidebar.opened) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('sidebarStatus', 1);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    }
  },
  actions: {
    ToggleSideBar: function ToggleSideBar(_ref) {
      var commit = _ref.commit;

      commit('TOGGLE_SIDEBAR');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),

/***/ "WTox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2WTH");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fe0397c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4+ci");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fe0397c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "X7ex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ScrollPane__ = __webpack_require__("sUix");

//
//
//
//
//
//
//
//
//
//
//




// import { generateTitle } from '@/utils/i18n'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userId: JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* getToken */])()).userId
    };
  },

  components: { ScrollPane: __WEBPACK_IMPORTED_MODULE_2__components_ScrollPane__["a" /* default */] },
  computed: {
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  },
  mounted: function mounted() {
    this.addViewTags();
  },

  methods: {
    // generateTitle,
    closeViewTags: function closeViewTags(view, $event) {
      var _this = this;

      this.$store.dispatch('delVisitedViews', view).then(function (views) {
        if (_this.isActive(view)) {
          var latestView = views.slice(-1)[0];
          if (latestView) {
            _this.$router.push(latestView.path);
          } else {
            _this.$router.push('/');
          }
        }
      });
      $event.preventDefault();
    },
    generateRoute: function generateRoute() {
      if (this.$route.name) {
        return this.$route;
      }
      return false;
    },
    addViewTags: function addViewTags() {
      var route = this.generateRoute();
      if (!route) {
        return false;
      }
      this.$store.dispatch('addVisitedViews', route);
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    moveToCurrentTag: function moveToCurrentTag() {
      var _this2 = this;

      var tags = this.$refs.tag;
      this.$nextTick(function () {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(tags), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var tag = _step.value;

            if (tag.to === _this2.$route.path) {
              _this2.$refs.scrollPane.moveToTarget(tag.$el);
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  },
  watch: {
    $route: function $route() {
      this.addViewTags();
      this.moveToCurrentTag();
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return constantRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return baseRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return customerRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return adminRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return bindAccountRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return adminAbroadRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return customerAbroadRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abroadRouterMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__ = __webpack_require__("AkUR");






var _import = __webpack_require__("A66B");
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* Layout */


/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
var constantRouterMap = [{ path: '/login', name: "login", component: _import('login/index'), hidden: true }, { path: '/forget', name: "forget", component: _import('forget/index'), hidden: true }, { path: '/register', name: 'register', component: _import('register/index'), hidden: true }, { path: '/404', component: _import('404'), hidden: true }, {
    path: '/account',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/account/index',
    name: 'accountInfo',
    hidden: true,
    meta: { role: "admin", title: '账号管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'account',
        hidden: true,
        component: _import('account/index'),
        meta: { title: '账号管理', icon: 'form', noCache: false }
    }]
}];

var baseRouterMap = [{
    path: '/',
    redirect: '/cpc/index'
}, {
    path: '/cpc',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/cpc/index',
    // name: 'order',
    meta: { role: "customer", title: 'CPC广告', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'cpc',
        hidden: false,
        component: _import('cpc/index'),
        meta: { role: "customer", title: 'CPC广告', icon: 'form', noCache: false }
    }]
}, {
    path: '/position',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    hidden: true,
    meta: { role: "admin", title: 'CPC广告位', icon: 'example', noCache: true },
    children: [{
        path: ':id',
        name: 'position',
        hidden: true,
        component: _import('position/index'),
        meta: { role: "customer", title: 'CPC广告位', icon: 'form', noCache: false },
        beforeEnter: function beforeEnter(to, from, next) {
            if (JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["a" /* getToken */])()).userId === 1791) {
                next();
            } else {
                __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"].error("没有权限进入此页面");
                next('404');
            }
        }
    }]
}, {
    path: '/position/:id',
    name: 'position',
    hidden: true,
    component: _import('position/index'),
    meta: { role: "customer", title: 'CPC广告位', icon: 'form', noCache: false },
    beforeEnter: function beforeEnter(to, from, next) {
        if (JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["a" /* getToken */])()).userId === 1109) {
            console.info(8588888);
            next();
        } else {
            console.info(99999);
            __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"].error("没有权限进入此页面");
            next('404');
        }
    }
}, {
    path: '/cpa',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/cpa/index',
    // name: 'order',
    meta: { role: "customer", title: 'CPA广告', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'cpa',
        hidden: false,
        component: _import('cpa/index'),
        meta: { role: "customer", title: 'CPA广告', icon: 'form', noCache: false }
    }]
}, {
    path: '/adadmin',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/adadmin/index',
    name: 'adadmin',
    meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'adadminIndex',
        hidden: false,
        component: _import('adadmin/index'),
        meta: { role: "customer", title: '广告管理', icon: 'form', noCache: false }
    }, {
        path: 'create',
        name: 'adadminCreate',
        hidden: true,
        component: _import('adadmin/create'),
        meta: { title: '新建计划', icon: 'form', noCache: false }
    }, {
        path: 'edit/:id',
        name: 'adadminEdit',
        hidden: true,
        component: _import('adadmin/create'),
        meta: { title: '编辑计划', icon: 'form', noCache: false }
    }, {
        path: 'look/:id',
        name: 'adadminLook',
        hidden: true,
        component: _import('adadmin/create'),
        meta: { title: '查看计划', icon: 'form', noCache: false }
    }, {
        path: 'adadminEditQualify/:id',
        name: 'adadminEditQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '编辑资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminLookQualify/:id',
        name: 'adadminLookQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '查看资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminCreateQualify',
        name: 'adadminCreateQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '新建资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminEditVideo/id/:id',
        name: 'adadminEditVideo',
        hidden: true,
        component: _import('adadmin/videoManagement/adadminCreateVideo'),
        meta: { title: '编辑视频', icon: 'form', noCache: false }
    }, {
        path: 'adadminCreateVideo',
        name: 'adadminCreateVideo',
        hidden: true,
        component: _import('adadmin/videoManagement/adadminCreateVideo'),
        meta: { title: '新建视频', icon: 'form', noCache: false }
    }, {
        path: 'qualifyManagement',
        name: 'adadminQualifyManagement',
        hidden: false,
        component: _import('adadmin/qualifyManagement/index'),
        meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
    }, {
        path: 'videoManagement',
        name: 'videoManagement',
        hidden: false,
        component: _import('adadmin/videoManagement/index'),
        meta: { role: "customer", title: '视频管理', icon: 'form', noCache: false }
    }]
}, {
    path: '/arrears',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/arrears/index',
    name: 'arrears',
    hidden: true,
    meta: { role: "admin", title: '欠款明细', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'arrearsIndex',
        hidden: true,
        component: _import('arrears/index'),
        meta: { title: '欠款明细', icon: 'form', noCache: false }
    }]
}, {
    path: '/user/notice',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/user/notice/index',
    name: 'notice',
    meta: { title: '消息中心', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'noticeIndex',
        component: _import('notice/index'),
        meta: { title: '消息中心', icon: 'form', noCache: false }
    }]
}];

var customerRouterMap = [{
    path: '/subfinance',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/subfinance/index',
    // name: 'order',
    // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'subfinance',
        hidden: true,
        component: _import('subfinance/index'),
        meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
    }]
}, {
    path: '/sublogs',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/sublogs/index',
    // name: 'order',
    // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'sublogs',
        hidden: true,
        component: _import('sublogs/index'),
        meta: { role: "customer", title: '券操作日志', icon: 'form', noCache: false }
    }]
}, { path: '*', redirect: '/404', hidden: true }];

var adminRouterMap = [{
    path: '/finance',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/finance/index',
    // name: 'order',
    // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'finance',
        hidden: true,
        component: _import('finance/index'),
        meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
    }]
}, {
    path: '/subaccount',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/subaccount/index',
    // name: 'order',
    // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'subaccount',
        hidden: true,
        component: _import('subaccount/index'),
        meta: { role: "customer", title: '子账号管理', icon: 'form', noCache: false }
    }]
}, {
    path: '/logs',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/logs/index',
    // name: 'order',
    // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'logs',
        hidden: true,
        component: _import('logs/index'),
        meta: { role: "customer", title: '券操作日志', icon: 'form', noCache: false }
    }]
}, { path: '*', redirect: '/404', hidden: true }];

// 绑定账户的广告主
var bindAccountRouterMap = [{
    path: '/',
    redirect: '/placeData/index'
}, {
    path: '/placeData',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/placeData/index',
    children: [{
        path: 'index',
        name: 'placeData',
        hidden: true,
        component: _import('placeData/index'),
        meta: { role: "customer", title: '投放数据', icon: 'form', noCache: false }
    }]
}, {
    path: '/adadmin',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/adadmin/qualifyManagement',
    name: 'adadmin',
    meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
    children: [{
        path: 'qualifyManagement',
        name: 'adadminQualifyManagement',
        hidden: false,
        component: _import('adadmin/qualifyManagement/index'),
        meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
    }, {
        path: 'adadminEditQualify/:id',
        name: 'adadminEditQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '编辑资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminLookQualify/:id',
        name: 'adadminLookQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '查看资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminCreateQualify',
        name: 'adadminCreateQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '新建资质', icon: 'form', noCache: false }
    }]
}];

// 海外admin
var adminAbroadRouterMap = [{
    path: '/',
    redirect: '/finance/index'
}, {
    path: '/adadmin',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/adadmin/qualifyManagement',
    name: 'adadmin',
    meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
    children: [{
        path: 'qualifyManagement',
        name: 'adadminQualifyManagement',
        hidden: false,
        component: _import('adadmin/qualifyManagement/index'),
        meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
    }, {
        path: 'index',
        name: 'adadminIndex',
        hidden: false,
        component: _import('adadmin/index'),
        meta: { role: "customer", title: '广告管理', icon: 'form', noCache: false }
    }, {
        path: 'create',
        name: 'adadminCreate',
        hidden: true,
        component: _import('adadmin/create'),
        meta: { title: '新建计划', icon: 'form', noCache: false }
    }, {
        path: 'edit/:id',
        name: 'adadminEdit',
        hidden: true,
        component: _import('adadmin/create'),
        meta: { title: '编辑计划', icon: 'form', noCache: false }
    }, {
        path: 'look/:id',
        name: 'adadminLook',
        hidden: true,
        component: _import('adadmin/create'),
        meta: { title: '查看计划', icon: 'form', noCache: false }
    }, {
        path: 'adadminEditQualify/:id',
        name: 'adadminEditQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '编辑资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminLookQualify/:id',
        name: 'adadminLookQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '查看资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminCreateQualify',
        name: 'adadminCreateQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '新建资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminEditVideo/id/:id',
        name: 'adadminEditVideo',
        hidden: true,
        component: _import('adadmin/videoManagement/adadminCreateVideo'),
        meta: { title: '编辑视频', icon: 'form', noCache: false }
    }, {
        path: 'adadminCreateVideo',
        name: 'adadminCreateVideo',
        hidden: true,
        component: _import('adadmin/videoManagement/adadminCreateVideo'),
        meta: { title: '新建视频', icon: 'form', noCache: false }
    }]
}, {
    path: '/finance',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/finance/index',
    children: [{
        path: 'index',
        name: 'finance',
        hidden: true,
        component: _import('finance/index'),
        meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
    }]
}, {
    path: '/subaccount',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/subaccount/index',
    children: [{
        path: 'index',
        name: 'subaccount',
        hidden: true,
        component: _import('subaccount/index'),
        meta: { role: "customer", title: '子账号管理', icon: 'form', noCache: false }
    }]
}, { path: '*', redirect: '/404', hidden: true }];
// 海外子账号
var customerAbroadRouterMap = [{
    path: '/',
    redirect: '/cpc/index'
}, {
    path: '/adadmin',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/adadmin/qualifyManagement',
    name: 'adadmin',
    meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
    children: [{
        path: 'qualifyManagement',
        name: 'adadminQualifyManagement',
        hidden: false,
        component: _import('adadmin/qualifyManagement/index'),
        meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
    }, {
        path: 'index',
        name: 'adadminIndex',
        hidden: false,
        component: _import('adadmin/index'),
        meta: { role: "customer", title: '广告管理', icon: 'form', noCache: false }
    }, {
        path: 'create',
        name: 'adadminCreate',
        hidden: true,
        component: _import('adadmin/create'),
        meta: { title: '新建计划', icon: 'form', noCache: false }
    }, {
        path: 'edit/:id',
        name: 'adadminEdit',
        hidden: true,
        component: _import('adadmin/create'),
        meta: { title: '编辑计划', icon: 'form', noCache: false }
    }, {
        path: 'look/:id',
        name: 'adadminLook',
        hidden: true,
        component: _import('adadmin/create'),
        meta: { title: '查看计划', icon: 'form', noCache: false }
    }, {
        path: 'adadminEditQualify/:id',
        name: 'adadminEditQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '编辑资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminLookQualify/:id',
        name: 'adadminLookQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '查看资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminCreateQualify',
        name: 'adadminCreateQualify',
        hidden: true,
        component: _import('adadmin/createQualify/index'),
        meta: { title: '新建资质', icon: 'form', noCache: false }
    }, {
        path: 'adadminEditVideo/id/:id',
        name: 'adadminEditVideo',
        hidden: true,
        component: _import('adadmin/videoManagement/adadminCreateVideo'),
        meta: { title: '编辑视频', icon: 'form', noCache: false }
    }, {
        path: 'adadminCreateVideo',
        name: 'adadminCreateVideo',
        hidden: true,
        component: _import('adadmin/videoManagement/adadminCreateVideo'),
        meta: { title: '新建视频', icon: 'form', noCache: false }
    }]
},
// {
//     path: '/finance',
//     component: Layout,
//     redirect: '/finance/index',
//     children: [{
//         path: 'index',
//         name: 'finance',
//         hidden: true,
//         component: _import('finance/index'),
//         meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
//     }]
// },
{ path: '*', redirect: '/404', hidden: true }];
// 海外路由
var abroadRouterMap = [{ path: '/login', name: "login", component: _import('login/index'), hidden: true }, { path: '/forget', name: "forget", component: _import('forget/index'), hidden: true }, { path: '/register', name: 'register', component: _import('register/index'), hidden: true }, { path: '/404', component: _import('404'), hidden: true },
// {
//     path: '/',
//     redirect: '/cpc/index',
// },
{
    path: '/cpc',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/cpc/index',
    // name: 'order',
    meta: { role: "customer", title: 'CPC广告', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'cpc',
        hidden: false,
        component: _import('cpc/index'),
        meta: { role: "customer", title: 'CPC广告', icon: 'form', noCache: false }
    }]
}, {
    path: '/position',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    hidden: true,
    meta: { role: "admin", title: 'CPC广告位', icon: 'example', noCache: true },
    children: [{
        path: ':id',
        name: 'position',
        hidden: true,
        component: _import('position/index'),
        meta: { role: "customer", title: 'CPC广告位', icon: 'form', noCache: false },
        beforeEnter: function beforeEnter(to, from, next) {
            if (JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["a" /* getToken */])()).userId === 1791) {
                next();
            } else {
                __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"].error("没有权限进入此页面");
                next('404');
            }
        }
    }]
}, {
    path: '/position/:id',
    name: 'position',
    hidden: true,
    component: _import('position/index'),
    meta: { role: "customer", title: 'CPC广告位', icon: 'form', noCache: false },
    beforeEnter: function beforeEnter(to, from, next) {
        if (JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["a" /* getToken */])()).userId === 1109) {
            console.info(8588888);
            next();
        } else {
            console.info(99999);
            __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"].error("没有权限进入此页面");
            next('404');
        }
    }
}, {
    path: '/cpa',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/cpa/index',
    // name: 'order',
    meta: { role: "customer", title: 'CPA广告', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'cpa',
        hidden: false,
        component: _import('cpa/index'),
        meta: { role: "customer", title: 'CPA广告', icon: 'form', noCache: false }
    }]
},
// {
//     path: '/adadmin',
//     component: Layout,
//     redirect: '/adadmin/qualifyManagement',
//     name: 'adadmin',
//     meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
//     children: [
//     {
//         path: 'qualifyManagement',
//         name: 'adadminQualifyManagement',
//         hidden: false,
//         component: _import('adadmin/qualifyManagement/index'),
//         meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
//     },
//     // {
//     //     path: 'index',
//     //     name: 'adadminIndex',
//     //     hidden: false,
//     //     component: _import('adadmin/index'),
//     //     meta: { role: "customer", title: '广告管理', icon: 'form', noCache: false }
//     // },
//     {
//         path: 'create',
//         name: 'adadminCreate',
//         hidden: true,
//         component: _import('adadmin/create'),
//         meta: { title: '新建计划', icon: 'form', noCache: false }
//     },
//     {
//         path: 'edit/:id',
//         name: 'adadminEdit',
//         hidden: true,
//         component: _import('adadmin/create'),
//         meta: { title: '编辑计划', icon: 'form', noCache: false }
//     },
//     {
//         path: 'look/:id',
//         name: 'adadminLook',
//         hidden: true,
//         component: _import('adadmin/create'),
//         meta: { title: '查看计划', icon: 'form', noCache: false }
//     },
//     {
//         path: 'adadminEditQualify/:id',
//         name: 'adadminEditQualify',
//         hidden: true,
//         component: _import('adadmin/createQualify/index'),
//         meta: { title: '编辑资质', icon: 'form', noCache: false }
//     },
//     {
//         path: 'adadminLookQualify/:id',
//         name: 'adadminLookQualify',
//         hidden: true,
//         component: _import('adadmin/createQualify/index'),
//         meta: { title: '查看资质', icon: 'form', noCache: false }
//     },
//     {
//         path: 'adadminCreateQualify',
//         name: 'adadminCreateQualify',
//         hidden: true,
//         component: _import('adadmin/createQualify/index'),
//         meta: { title: '新建资质', icon: 'form', noCache: false }
//     },
//     {
//         path: 'adadminEditVideo/id/:id',
//         name: 'adadminEditVideo',
//         hidden: true,
//         component: _import('adadmin/videoManagement/adadminCreateVideo'),
//         meta: { title: '编辑视频', icon: 'form', noCache: false }
//     },
//     {
//         path: 'adadminCreateVideo',
//         name: 'adadminCreateVideo',
//         hidden: true,
//         component: _import('adadmin/videoManagement/adadminCreateVideo'),
//         meta: { title: '新建视频', icon: 'form', noCache: false }
//     }]
// },
// {
//     path: '/finance',
//     component: Layout,
//     redirect: '/finance/index',
//     children: [{
//         path: 'index',
//         name: 'finance',
//         hidden: true,
//         component: _import('finance/index'),
//         meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
//     }]
// },
{
    path: '/arrears',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/arrears/index',
    name: 'arrears',
    hidden: true,
    meta: { role: "admin", title: '欠款明细', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'arrearsIndex',
        hidden: true,
        component: _import('arrears/index'),
        meta: { title: '欠款明细', icon: 'form', noCache: false }
    }]
}, {
    path: '/account',
    component: __WEBPACK_IMPORTED_MODULE_5__views_layout_Layout__["default"],
    redirect: '/account/index',
    name: 'accountInfo',
    hidden: true,
    meta: { role: "admin", title: '账号管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'account',
        hidden: true,
        component: _import('account/index'),
        meta: { title: '账号管理', icon: 'form', noCache: false }
    }]
}];

/* harmony default export */ __webpack_exports__["i"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    // mode: 'history', //后端支持可开
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    // 判断是否海外}
    routes: localStorage.getItem('areaType') == 1 ? abroadRouterMap : constantRouterMap
}));

/***/ }),

/***/ "Z451":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

var padding = 15; // tag's padding

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scrollPane',
  data: function data() {
    return {
      left: 0
    };
  },

  methods: {
    handleScroll: function handleScroll(e) {
      var eventDelta = e.wheelDelta || -e.deltaY * 3;
      var $container = this.$refs.scrollContainer;
      var $containerWidth = $container.offsetWidth;
      var $wrapper = this.$refs.scrollWrapper;
      var $wrapperWidth = $wrapper.offsetWidth;

      if (eventDelta > 0) {
        this.left = Math.min(0, this.left + eventDelta);
      } else {
        if ($containerWidth - padding < $wrapperWidth) {
          if (this.left < -($wrapperWidth - $containerWidth + padding)) {
            this.left = this.left;
          } else {
            this.left = Math.max(this.left + eventDelta, $containerWidth - $wrapperWidth - padding);
          }
        } else {
          this.left = 0;
        }
      }
    },
    moveToTarget: function moveToTarget($target) {
      var $container = this.$refs.scrollContainer;
      var $containerWidth = $container.offsetWidth;
      var $targetLeft = $target.offsetLeft;
      var $targetWidth = $target.offsetWidth;

      if ($targetLeft < -this.left) {
        // tag in the left
        this.left = -$targetLeft + padding;
      } else if ($targetLeft + padding > -this.left && $targetLeft + $targetWidth < -this.left + $containerWidth - padding) {
        // tag in the current view
        // eslint-disable-line
      } else {
        // tag in the right
        this.left = -($targetLeft - ($containerWidth - $targetWidth) + padding);
      }
    }
  }
});

/***/ }),

/***/ "Z7ZQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zq5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);




var tagsView = {
  state: {
    visitedViews: [],
    cachedViews: []
  },
  mutations: {
    ADD_VISITED_VIEWS: function ADD_VISITED_VIEWS(state, view) {
      if (state.visitedViews.some(function (v) {
        return v.path === view.path;
      })) return;
      state.visitedViews.push({
        name: view.name,
        path: view.path,
        title: (view.query.tagName ? view.query.tagName : view.meta.title) || 'no-name'
      });
      if (!view.meta.noCache) {
        state.cachedViews.push(view.name);
      }
    },
    DEL_VISITED_VIEWS: function DEL_VISITED_VIEWS(state, view) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var i = _ref2[0];
          var v = _ref2[1];

          if (v.path === view.path) {
            state.visitedViews.splice(i, 1);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.cachedViews), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _i = _step2.value;

          if (_i === view.name) {
            var index = state.cachedViews.indexOf(_i);
            state.cachedViews.splice(index, 1);
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  },
  actions: {
    addVisitedViews: function addVisitedViews(_ref3, view) {
      var commit = _ref3.commit;

      commit('ADD_VISITED_VIEWS', view);
    },
    delVisitedViews: function delVisitedViews(_ref4, view) {
      var commit = _ref4.commit,
          state = _ref4.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('DEL_VISITED_VIEWS', view);
        resolve([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.visitedViews)));
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (tagsView);

/***/ }),

/***/ "aret":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_components__ = __webpack_require__("6gxQ");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'layout',
    components: {
        Navbar: __WEBPACK_IMPORTED_MODULE_0__views_layout_components__["b" /* Navbar */],
        Sidebar: __WEBPACK_IMPORTED_MODULE_0__views_layout_components__["c" /* Sidebar */],
        AppMain: __WEBPACK_IMPORTED_MODULE_0__views_layout_components__["a" /* AppMain */],
        TagsView: __WEBPACK_IMPORTED_MODULE_0__views_layout_components__["d" /* TagsView */]
    },
    computed: {
        sidebar: function sidebar() {
            return this.$store.state.app.sidebar;
        }
    },
    created: function created() {
        var _this = this;

        var areaType = localStorage.getItem('areaType');
        // 获取消息通知
        if (areaType == '0') {
            this.$store.dispatch('GetNoticeCount').then(function (res) {
                if (res < 1 || _this.$route.path === '/user/notice') return;
                var notify = _this.$notify({
                    title: '消息通知',
                    message: '\u60A8\u6709<strong>' + res + '</strong>\u6761\u6D88\u606F\u901A\u77E5\u672A\u9605\u8BFB',
                    dangerouslyUseHTMLString: true,
                    duration: 10000,
                    customClass: 'cursor-pointer',
                    position: 'top-right',
                    offset: 0,
                    onClick: function onClick() {
                        notify.close();
                        _this.$router.push('/user/notice');
                    }
                });
            });
        }
    }
});

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_login__ = __webpack_require__("M9A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_user__ = __webpack_require__("vMJZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__("TIfe");





var tokenInfo = Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["a" /* getToken */])();
var user = {
  state: {
    token: tokenInfo ? JSON.parse(tokenInfo).token || '' : '',
    name: '',
    avatar: '',
    roles: '',
    noticeCount: 0
  },

  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_NOTICE_COUNT: function SET_NOTICE_COUNT(state, count) {
      state.noticeCount = Math.max(count, 0);
    }
  },

  actions: {
    // 登录
    Login: function Login(_ref, userInfo) {
      var commit = _ref.commit;

      var username = userInfo.username.trim();

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_1__api_login__["c" /* postLogin */])(username, userInfo.password, userInfo.smscode).then(function (response) {
          var data = response.returnValue;
          Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["c" /* setToken */])({ userId: data.id });
          commit('SET_TOKEN', data.token);
          window.localStorage.setItem('ownSite', data.ownSite);
          //   commit('SET_OWNSITE', data.ownSite)
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 获取用户信息
    GetInfo: function GetInfo(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;


      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_1__api_login__["b" /* getInfo */])(state.token).then(function (response) {
          var data = response.returnValue;
          // debugger;
          commit('SET_ROLES', data.accountType + "");
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 登出
    LogOut: function LogOut(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('SET_TOKEN', '');
      commit('SET_ROLES', '');
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["b" /* removeToken */])();
      // return new Promise((resolve, reject) => {
      //   logout(state.token).then(() => {
      //     commit('SET_TOKEN', '')
      //     commit('SET_ROLES', [])
      //     removeToken()
      //     resolve()
      //   }).catch(error => {
      //     reject(error)
      //   })
      // })
    },


    // 前端 登出
    FedLogOut: function FedLogOut(_ref4) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('SET_TOKEN', '');
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["b" /* removeToken */])();
        resolve();
      });
    },


    // 获取消息通知的数量
    GetNoticeCount: function GetNoticeCount(_ref5) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_2__api_user__["b" /* noreadNotice */])().then(function (res) {
          commit('SET_NOTICE_COUNT', res || 0);
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ "bn4E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dahE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("SM0Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebcc730_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("KWC7");
function injectStyle (ssrContext) {
  __webpack_require__("B42Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ebcc730"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebcc730_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gPq7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Breadcrumb__ = __webpack_require__("UqIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hamburger__ = __webpack_require__("dahE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components_Breadcrumb__["a" /* default */],
    Hamburger: __WEBPACK_IMPORTED_MODULE_3__components_Hamburger__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sidebar', 'avatar'])),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
    },
    logout: function logout() {
      this.$store.dispatch('LogOut').then(function () {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
      localStorage.removeItem('areaType');
    }
  }
});

/***/ }),

/***/ "gzxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("yeib");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713db3de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("CV2m");
function injectStyle (ssrContext) {
  __webpack_require__("I4X8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-713db3de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713db3de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hRxV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kTXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_auth__ = __webpack_require__("TIfe");



 // Progress 进度条
 // Progress 进度条样式

 // 验权

// permissiom judge
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true; // admin权限 直接通过
  if (!permissionRoles) return true;
  return roles.some(function (role) {
    return permissionRoles.indexOf(role) >= 0;
  });
}

var whiteList = ['/login', '/register', '/forget']; // 不重定向白名单
__WEBPACK_IMPORTED_MODULE_1__router__["i" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.start();
  // console.log(getToken())
  if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_auth__["a" /* getToken */])()) {
    // next()

    // store.dispatch('GenerateRoutes', { roles }).then(() => { // 生成可访问的路由表
    //   router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
    //   next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,replace: true so the navigation will not leave a history record
    // })
    // next()

    if (to.path === '/login') {
      next({ path: '/' });
      __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done(); // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    } else {

      if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.roles == '') {
        // 判断当前用户是否已拉取完user_info信息
        // debugger;
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('GetInfo').then(function (response) {
          // 拉取user_info
          var data = response.returnValue;
          // 判断海内海外
          var areaType = void 0;
          var locationPath = window.location.href;
          var reg = RegExp(/overseas/);
          areaType = reg.test(locationPath) ? 1 : 0;
          localStorage.setItem('areaType', areaType);
          localStorage.setItem('accountType', data.accountType);
          localStorage.setItem('LJ_sp', data.scanPrice);
          // debugger;
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('GenerateRoutes', data).then(function () {
            // 生成可访问的路由表
            __WEBPACK_IMPORTED_MODULE_1__router__["i" /* default */].addRoutes(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.addRouters); // 动态添加可访问路由表
            next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to, { replace: true })); // hack方法 确保addRoutes已完成 ,replace: true so the navigation will not leave a history record
          }).catch(function () {});
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('FedLogOut').then(function () {
            __WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"].error('验证失败,请重新登录');
            next({ path: '/login' });
          });
        });
      } else {
        next();
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        // if (hasPermission(store.getters.roles, to.meta.role)) {
        //   next()//
        // } else {
        //   next({ path: '/401', query: { noGoBack: true }})
        //   NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
        // }
        // 可删 ↑
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/login');
      __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done();
    }
  }
});
__WEBPACK_IMPORTED_MODULE_1__router__["i" /* default */].afterEach(function () {
  __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done(); // 结束Progress
});

/***/ }),

/***/ "l1x3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__("TIfe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SidebarItem',
  data: function data() {
    return {
      userId: JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["a" /* getToken */])()).userId,
      // 自建站广告主ID白名单
      diysiteIds: [132, 133, 179, 256, 472, 476, 526, 631, 675, 696, 704, 1109, 1131, 1143, 1152, 1156, 1159, 1186, 1225, 1279, 1287, 1288, 1301, 1312, 1314, 1363, 1364, 1383, 1437, 1440, 1445, 1448, 1455, 1458, 1464, 1496, 1580, 1675, 1680, 1732, 1757, 1788, 1795, 1842, 1843, 1844, 1959, 2057, 2060, 2097, 2103, 2129, 2130, 2131, 2148, 2176, 2206, 2301, 2360, 2361, 2365, 2366, 2367, 2368, 2377, 2395, 2397, 2402, 2407, 2416, 2425, 2436, 2437, 2438, 2442, 2443, 2472, 2996]
    };
  },

  props: {
    routes: {
      type: Array
    }
  },
  //   computed(){
  //        ownSite:function(){
  //                     return this.$store.getters.ownSite;
  //             }
  //   },
  created: function created() {
    this.userId = JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["a" /* getToken */])()).userId;
    // console.log("++++++++++++++++" + this.userId);
  },

  methods: {
    hidePage: function hidePage(item) {
      if (item.name == 'diysite') {
        var ownSite = window.localStorage.getItem('ownSite');
        if (ownSite == 'false') {
          return true;
        } else {
          return false;
        }

        //   return !item.isOwnSite;
        // return !(this.diysiteIds.indexOf(this.userId) > -1);
      }
    }
  }
});

/***/ }),

/***/ "n6L1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"navbar",attrs:{"mode":"horizontal"}},[_c('hamburger',{staticClass:"hamburger-container",attrs:{"toggleClick":_vm.toggleSideBar,"isActive":_vm.sidebar.opened}}),_vm._v(" "),_c('breadcrumb'),_vm._v(" "),_c('el-dropdown',{staticClass:"avatar-container",attrs:{"trigger":"click"}},[_c('div',{staticClass:"avatar-wrapper"},[_vm._v("\n      会员中心\n      "),_c('i',{staticClass:"el-icon-caret-bottom"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"user-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('router-link',{staticClass:"inlineBlock",attrs:{"to":{ name: 'accountInfo' }}},[_c('el-dropdown-item',[_vm._v("\n         账号管理\n        ")])],1),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":""}},[_c('span',{staticStyle:{"display":"block"},on:{"click":_vm.logout}},[_vm._v("退出")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oSYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-table",
  "use": "icon-table-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-table\"><defs><style type=\"text/css\"></style></defs><path d=\"M568.6 0h454.9v454.9H568.6V0z m0 568.6h454.9v454.9H568.6V568.6zM0 568.6h454.9v454.9H0V568.6zM0 0h454.9v454.9H0V0z\" fill=\"\" p-id=\"5071\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "p7/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sTIr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-form",
  "use": "icon-form-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-form\"><defs><style type=\"text/css\"></style></defs><path d=\"M942.827259 80.3367c-11.42419-11.406794-26.41051-17.117866-41.377386-17.117866-14.985296 0-29.952172 5.711072-41.358967 17.117866L719.392444 221.014696l-19.441794 19.441794L681.577187 258.832 569.516971 370.909611 375.99749 564.411697l0 0.019443 0 84.372619 81.145112 0 0.010233 0 95.418186-95.435583 213.398228-213.400275 3.14155-3.14155-0.019443 0 9.979282-9.977235 0 0L942.827259 163.073052C965.697129 140.259464 965.697129 103.186104 942.827259 80.3367z\" p-id=\"3231\" /><path d=\"M793.542234 367.521444 580.14196 580.939115 484.72582 676.376745 473.299583 687.800935 457.152834 687.800935 375.99749 687.800935 337.000314 687.800935 337.000314 648.803759 337.000314 564.411697 337.000314 548.264948 348.424504 536.838711 541.943986 343.338672 654.004201 231.259014 665.428392 219.834824 64.020082 219.834824 64.020082 960.781166 804.966425 960.781166 804.966425 356.116697 796.607036 364.475062Z\" p-id=\"3232\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "sUix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z451");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5b9f752_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("xgjc");
function injectStyle (ssrContext) {
  __webpack_require__("Z7ZQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5b9f752"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5b9f752_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "svnb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tlvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("l1x3");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7dac5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("2gz9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7dac5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uXQy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-pane',{ref:"scrollPane",staticClass:"tags-view-container"},_vm._l((Array.from(_vm.visitedViews)),function(tag){return _c('router-link',{key:tag.path,ref:"tag",refInFor:true,staticClass:"tags-view-item",class:_vm.isActive(tag)?'active':'',attrs:{"to":tag.path}},[((_vm.userId == 653 || _vm.userId == 1016 || _vm.userId == 2990) && tag.title == 'CPA广告')?[_vm._v("非标广告")]:[_vm._v(_vm._s(tag.title))],_vm._v(" "),_c('span',{staticClass:"el-icon-close",on:{"click":function($event){return _vm.closeViewTags(tag,$event)}}})],2)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vLgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = uploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_index__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_qs__);








// import { getToken } from '@/utils/auth';



// axios.defaults.withCredentials = true;
// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
    withCredentials: true,
    baseURL: "https://cpcapi.fuguifanrongwl.com/", // api的base_url
    timeout: 150000000 // 请求超时时间
});

var cookieInfo = {};
// request拦截器


service.interceptors.request.use(function (config) {
    // console.log(cookieInfo);
    // config.params.userId = cookieInfo.userId
    // config.data.userId = cookieInfo.userId
    // if(getToken()) {
    //     cookieInfo = JSON.parse(getToken());
    // }
    // if (store.getters.token) {
    //   config.headers['token'] = cookieInfo.token // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    // if(config.method === "post") {
    //   config.data.userId = cookieInfo.userId
    //   config.data = qs.stringify(config.data);
    // } else {
    //   config.params.userId = cookieInfo.userId
    // }

    // if (store.getters.token) {
    //   config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    config.headers['channel'] = 1;
    if (config.method === "post") {
        config.data = __WEBPACK_IMPORTED_MODULE_9_qs___default.a.stringify(config.data);
    }
    return config;
}, function (error) {
    console.log(error); // for debug
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(error);
});

// response 拦截器
service.interceptors.response.use(function (response) {
    // code为非20000是抛错 可结合自己业务进行修改
    var res = response.data;
    if (res.successed === false) {
        __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"].error(res.errorDesc || '系统错误');
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject('error');
    } else {
        return response.data;
    }
}, function (error) {
    __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"].error(error.message);
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/**
 * 上传文件（支持多个文件）
 * @param {string} url 接口路径
 * @param {File | File[]} files 单个或多个文件对象，File可以是 Blob 对象
 * @param [options]
 * @param {string} [options.name] 文件表单项的 name
 * @param {object} [options.headers] 自定义请求头
 * @param {function} [options.onUploadProgress] 上传进度的监听函数
 * */
function uploadFile(url, files) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var errMsg = '';
    if (!url) {
        errMsg = '接口地址不能为空';
        __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"].error(errMsg);
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }

    if (!files || Array.isArray(files) && !files.length) {
        errMsg = '请选择文件';
        __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"].error(errMsg);
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }

    var token = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.user.token; // 注意：广告主后台没有返回 token 值
    // 处理 url 参数
    var query = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_index__["d" /* parseUrlSearch */])(url), {
        token: token
    })).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return key + '=' + value;
    }).join('&');
    // 完整的请求 url
    var domain = !/^https?:/.test(url) ? "https://cpcapi.fuguifanrongwl.com/" : '';
    var serverUrl = '' + domain + url.replace(/\?.*/, '') + '?' + query;
    // 表单数据对象
    var formData = new FormData();
    // 文件表单项的 name
    var fileFieldName = options.name || 'file';
    // 表单头
    var headers = {
        'Content-Type': 'multipart/form-data',
        'token': token
    };

    if (options.headers) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(headers, options.headers);
    }

    // Content-Disposition: form-data; name="file"; filename="300x300.png"
    if (Array.isArray(files)) {
        files.forEach(function (file, index) {
            // 多个文件时，filename 不能重复
            formData.append(fileFieldName + (index ? index + 1 : ''), file, file.name);
        });
    } else {
        formData.append(fileFieldName, files, files.name);
    }

    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var ops = {
            headers: headers,
            onUploadProgress: options.onUploadProgress
        };
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(serverUrl, formData, ops).then(function (response) {
            var res = response.data || {};
            if (!res) {
                var _errMsg = '上传失败';
                __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"].error(_errMsg);
                reject(_errMsg);
            } else {
                // 每个接口返回的结果可能不同，需自行处理
                resolve(res);
            }
        }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"].error(err.message);
            reject(err);
        });
    });
}

/***/ }),

/***/ "vMJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNoticeList;
/* harmony export (immutable) */ __webpack_exports__["b"] = noreadNotice;
/* unused harmony export deleteNotice */
/* harmony export (immutable) */ __webpack_exports__["c"] = readNotice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__("vLgD");


// 站内信消息列表
function getNoticeList(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
        url: '/stationMsg/getMessageList',
        method: 'get',
        params: params,
        noRemoveEmptyProps: true
    });
}

// 站内信消息列表
function noreadNotice(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
        url: '/stationMsg/getUnreadMsgCount',
        method: 'get',
        params: params
    });
}

// 删除站内信
function deleteNotice(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
        url: '/stationMsg/delete',
        method: 'delete',
        params: params
    });
}

// 读站内信
function readNotice(id) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
        url: '/stationMsg/messageOperate?messageId=' + id,
        method: 'post'
    });
}

/***/ }),

/***/ "wE0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wp/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("C3aA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e010f7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("5tQS");
function injectStyle (ssrContext) {
  __webpack_require__("Bpxs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43e010f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e010f7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xgjc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainer",staticClass:"scroll-container",on:{"wheel":function($event){$event.preventDefault();return _vm.handleScroll.apply(null, arguments)}}},[_c('div',{ref:"scrollWrapper",staticClass:"scroll-wrapper",style:({left: _vm.left + 'px'})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yeib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

var delta = 15;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scrollBar',
  data: function data() {
    return {
      top: 0
    };
  },

  methods: {
    handleScroll: function handleScroll(e) {
      e.preventDefault();
      var $container = this.$refs.scrollContainer;
      var $containerHeight = $container.offsetHeight;
      var $wrapper = this.$refs.scrollWrapper;
      var $wrapperHeight = $wrapper.offsetHeight;
      if (e.wheelDelta > 0) {
        this.top = Math.min(0, this.top + e.wheelDelta);
      } else {
        if ($containerHeight - delta < $wrapperHeight) {
          if (this.top < -($wrapperHeight - $containerHeight + delta)) {
            this.top = this.top;
          } else {
            this.top = Math.max(this.top + e.wheelDelta, $containerHeight - $wrapperHeight - delta);
          }
        } else {
          this.top = 0;
        }
      }
    }
  }
});

/***/ })

},[1]);


// WEBPACK FOOTER //
// static/js/app.0e0de3cfadcaf1588d0e.js